import * as THREE from "three";
import { CSS2DObject } from "three-stdlib";
import { stripNamespacePrefix } from "../../utils/nameUtils";
import { createBodyLabelElement } from "../labelUtils";

const BODY_LABEL_OFFSET = new THREE.Vector3(0, 0, 0);
export const BODY_LABEL_MARKER_RADIUS = 0.01;
const BODY_LABEL_MARKER_PICK_RADIUS = 0.063;
const BODY_LABEL_MARKER_GEOMETRY = new THREE.SphereGeometry(BODY_LABEL_MARKER_RADIUS, 20, 16);
const BODY_LABEL_MARKER_PICK_GEOMETRY = new THREE.SphereGeometry(
  BODY_LABEL_MARKER_PICK_RADIUS,
  12,
  8
);

export function addBodyLabelMarker(bodyNode, poseGroup) {
  if (!bodyNode?.uuid || !poseGroup) return;

  const bodyLabel = stripNamespacePrefix(bodyNode.name || "") || "body";
  const markerGroup = new THREE.Group();
  markerGroup.name = `${bodyNode.name || bodyNode.uuid}_bodyLabelMarker`;
  markerGroup.visible = false;
  markerGroup.userData = {
    type: "body",
    bodyUuid: bodyNode.uuid,
    bodyName: bodyNode.name || "",
    isBodyLabelMarker: true,
    isBodyLabelMarkerRoot: true,
  };

  const marker = new THREE.Mesh(
    BODY_LABEL_MARKER_GEOMETRY,
    new THREE.MeshBasicMaterial({
      color: 0x60a5fa,
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: 0.95,
    })
  );
  marker.renderOrder = 10001;
  marker.visible = false;
  marker.userData = {
    ...markerGroup.userData,
    selectable: true,
    isBodyLabelMarkerRoot: false,
    isBodyLabelMarkerVisual: true,
  };
  markerGroup.add(marker);

  const pickProxy = new THREE.Mesh(
    BODY_LABEL_MARKER_PICK_GEOMETRY,
    new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0,
      depthTest: false,
      depthWrite: false,
    })
  );
  pickProxy.renderOrder = 10001;
  pickProxy.visible = false;
  pickProxy.userData = {
    ...markerGroup.userData,
    selectable: true,
    isBodyLabelMarkerRoot: false,
    isBodyLabelMarkerPickProxy: true,
  };
  markerGroup.add(pickProxy);
  poseGroup.add(markerGroup);

  const labelDiv = createBodyLabelElement({
    text: bodyLabel,
    onClick: (event) => {
      event.stopPropagation();
      window.dispatchEvent(
        new CustomEvent("body-label-click", {
          detail: { bodyUuid: bodyNode.uuid, bodyName: bodyNode.name || "" },
        })
      );
    },
  });

  const label = new CSS2DObject(labelDiv);
  label.position.copy(BODY_LABEL_OFFSET);
  label.center.set(0, 0.5);
  label.element.style.marginLeft = "8px";
  label.visible = false;
  label.userData = {
    ...(label.userData || {}),
    type: "body",
    bodyUuid: bodyNode.uuid,
    bodyName: bodyLabel,
    isBodyLabelMarkerLabel: true,
    isBodyLabel: true,
  };
  poseGroup.add(label);
}
